"use strict";
exports = module.exports = require(8);

exports.build = "full";

// Parser
exports.tokenize         = require(25);
exports.parse            = require(17);
exports.common           = require(2);

// Configure parser
exports.Root._configure(exports.Type, exports.parse, exports.common);
